import { API_URL, CapitalizeFirstWord } from "../../helpers/utils";
import axios from "axios";
import {
  catchHandler,
  dispatchError,
  dispatchLoading,
  dispatchToast,
  elseHandler,
} from "../../helpers/dispatch";
import {
  decryptByText,
  requestPayloadBodyFormate,
  responseDataFormate,
} from "../../helpers/bycrypt";
import { NavigateFunction } from "react-router-dom";
import axiosInstance from "../../helpers/axios";
import {
  formatAttributes,
  transformItemsByVariant,
} from "../Pages/Orders/orderTypes";

let installationListCancelTokenSource: any;

export const GetInstallationListAPI =
  (
    {
      page,
      limit,
      search,
      status,
      customer_id,
      is_active,
      start_date,
      end_date,
      sortBy,
      order,
      created_by,
      start_at,
      end_at,
    }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInstallationData", true);
    if (installationListCancelTokenSource) {
      installationListCancelTokenSource.cancel("Previous request cancelled");
    }
    installationListCancelTokenSource = axios.CancelToken.source();
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (status) params["status"] = status;
    if (customer_id) params["customer_id"] = customer_id;
    if (created_by) params["created_by"] = created_by;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (start_at) params["start_at"] = start_at;
    if (end_at) params["end_at"] = end_at;
    if (sortBy) params["sortBy"] = sortBy;
    if (order) params["order"] = order;
    if (order) params["order"] = order;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/orders/installation-planning`, {
        params: { ...params },
        cancelToken: installationListCancelTokenSource.token,
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_INSTALLATION_DATA",
            payload: {
              page: page,
              data: result?.data?.data,
              count: result?.data?.count,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.data?.length == limit);
          }
          dispatchLoading(dispatch, "getInstallationData", false);
        } else elseHandler(dispatch, "getInstallationData", result);
        dispatchLoading(dispatch, "getInstallationData", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInstallationData")(err);
        // navigate("/auth/login");
      });
  };

export const GetInstallationDetailsAPI =
  ({ id }: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getInstallationDetails", true);
    let params: any = {};
    if (id) params["id"] = id;

    axiosInstance
      .get(`/orders/installation-planning`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          dispatch({
            type: "GET_INSTALLATION_DETAILS",
            payload: result?.data?.data[0],
          });

          dispatchLoading(dispatch, "getInstallationDetails", false);
        } else elseHandler(dispatch, "getInstallationDetails", result);
        dispatchLoading(dispatch, "getInstallationDetails", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getInstallationDetails")(err);
        // navigate("/auth/login");
      });
  };

export const GetPlanHiredServicesAPI =
  (
    {
      page,
      limit,
      search,
      status,
      customer_id,
      is_active,
      start_date,
      end_date,
      sortBy,
      order,
      is_hire_service,
    }: any,
    setHasMore: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "getPlanHiredServices", true);
    let params: any = {};
    if (page) params["page"] = page;
    if (limit) params["limit"] = limit;
    if (search) params["search"] = search;
    if (status) params["status"] = status;
    if (customer_id) params["customer_id"] = customer_id;
    if (is_hire_service) params["is_hire_service"] = is_hire_service;
    if (start_date) params["start_date"] = start_date;
    if (end_date) params["end_date"] = end_date;
    if (sortBy) params["sortBy"] = sortBy;
    if (order) params["order"] = order;
    if (is_active || is_active === 0) params["is_active"] = is_active;

    axiosInstance
      .get(`/services/list`, {
        params: { ...params },
        withCredentials: false,
      })
      .then((response) => {
        let result = responseDataFormate(response.data);
        if (result?.success) {
          // const newData = result?.data?.orders?.map((order: any) => ({
          //   ...order,
          //   order_created_by: order?.order_created_by
          //     ? {
          //         ...order?.order_created_by,
          //         email: decryptByText(order?.order_created_by?.email),
          //         first_name: CapitalizeFirstWord(
          //           decryptByText(order?.order_created_by?.first_name),
          //         ),
          //         last_name: CapitalizeFirstWord(
          //           decryptByText(order?.order_created_by?.last_name),
          //         ),
          //       }
          //     : order?.created_by,
          // }));
          dispatch({
            type: "GET_PLANT_HIRED_SERVICES_DATA",
            payload: {
              page: page,
              data: result?.data?.services,
              count: result?.pagination?.total,
            },
          });
          if (setHasMore) {
            setHasMore(result?.data?.services?.length == limit);
          }
          dispatchLoading(dispatch, "getPlanHiredServices", false);
        } else elseHandler(dispatch, "getPlanHiredServices", result);
        dispatchLoading(dispatch, "getPlanHiredServices", false);
      })
      .catch((err) => {
        catchHandler(dispatch, "getPlanHiredServices")(err);
        // navigate("/auth/login");
      });
  };

export const UpdateInstallationPlanAPI =
  (data: any, onClose: any) => async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "updatedInstallationPlan", true);
    const formatedData = requestPayloadBodyFormate(data);
    axiosInstance
      .put(`/orders/installation-planning/${data?.planning_id}`, formatedData, {
        withCredentials: true,
      })
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onClose) {
            onClose();
          }
          dispatchToast(dispatch, "success", result?.message);
          dispatchError(dispatch, "updatedInstallationPlan", undefined);
        } else elseHandler(dispatch, "updatedInstallationPlan", result);
        dispatchLoading(dispatch, "updatedInstallationPlan", false);
      })
      .catch(catchHandler(dispatch, "updatedInstallationPlan"));
  };

export const UpdateInstallationPlanIssuesAPI =
  (planning_id: string, issues: any, onSuccess: any) =>
  async (dispatch: (action: any) => void, getState: () => any) => {
    dispatchLoading(dispatch, "updatedInstallationPlanIssues", true);
    const formatedData = requestPayloadBodyFormate({ issues });
    axiosInstance
      .put(
        `/orders/installation-planning/${planning_id}/issues`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const currentDetails = getState()?.installationPlan?.installationPlanDetails;
          if (currentDetails && result?.data) {
            dispatch({
              type: "GET_INSTALLATION_DETAILS",
              payload: {
                ...currentDetails,
                status: result?.data?.status,
                old_status: result?.data?.old_status,
                issue: result?.data?.issue,
              },
            });
          }
          if (onSuccess) {
            onSuccess();
          }
          dispatchToast(
            dispatch,
            "success",
            issues[0]?._id
              ? "Issues updated successfully"
              : "Issues added successfully",
          );
          dispatchError(dispatch, "updatedInstallationPlanIssues", undefined);
        } else elseHandler(dispatch, "updatedInstallationPlanIssues", result);
        dispatchLoading(dispatch, "updatedInstallationPlanIssues", false);
      })
      .catch(catchHandler(dispatch, "updatedInstallationPlanIssues"));
  };

export const UpdateInstallationPlanIssueStatusAPI =
  (planning_id: string, issue_id: string, status: "open" | "close", onSuccess: any) =>
  async (dispatch: (action: any) => void, getState: () => any) => {
    dispatchLoading(dispatch, "updateInstallationPlanIssueStatus", true);
    const formatedData = requestPayloadBodyFormate({ status });
    axiosInstance
      .put(
        `/orders/installation-planning/${planning_id}/issues/${issue_id}/status`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          const currentDetails = getState()?.installationPlan?.installationPlanDetails;
          if (currentDetails && result?.data) {
            dispatch({
              type: "GET_INSTALLATION_DETAILS",
              payload: {
                ...currentDetails,
                status: result?.data?.status,
                old_status: result?.data?.old_status,
                issue: result?.data?.issue,
              },
            });
          }
          if (onSuccess) {
            onSuccess();
          }
          dispatchToast(
            dispatch,
            "success",
            status === "close" ? "Issue closed successfully" : "Issue reopened successfully"
          );
          dispatchError(dispatch, "updateInstallationPlanIssueStatus", undefined);
        } else elseHandler(dispatch, "updateInstallationPlanIssueStatus", result);
        dispatchLoading(dispatch, "updateInstallationPlanIssueStatus", false);
      })
      .catch(catchHandler(dispatch, "updateInstallationPlanIssueStatus"));
  };

export const UpdateInstallationPlanReadinessChecklistAPI =
  (
    planning_id: string,
    payload: {
      checklist_id: string;
      section_id: string;
      question_id?: string;
      answer: any;
      conditional?: any;
    },
    onSuccess: any,
  ) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(
      dispatch,
      "updatedInstallationPlanReadinessChecklist",
      true,
    );
    const formatedData = requestPayloadBodyFormate(payload);
    axiosInstance
      .put(
        `/orders/installation-planning/${planning_id}/readiness-checklist`,
        formatedData,
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) {
            onSuccess(result?.data);
          }
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Readiness checklist updated successfully",
          );
          dispatchError(
            dispatch,
            "updatedInstallationPlanReadinessChecklist",
            undefined,
          );
        } else
          elseHandler(
            dispatch,
            "updatedInstallationPlanReadinessChecklist",
            result,
          );
        dispatchLoading(
          dispatch,
          "updatedInstallationPlanReadinessChecklist",
          false,
        );
      })
      .catch(
        catchHandler(dispatch, "updatedInstallationPlanReadinessChecklist"),
      );
  };

export const ReloadInstallationPlanReadinessChecklistAPI =
  (planning_id: string, onSuccess: any) =>
  async (dispatch: (action: any) => void) => {
    dispatchLoading(dispatch, "reloadInstallationPlanReadinessChecklist", true);
    axiosInstance
      .put(
        `/orders/installation-planning/${planning_id}/reload-readiness-checklist`,
        {},
        {
          withCredentials: true,
        },
      )
      .then((response: any) => {
        let result = responseDataFormate(response?.data);
        if (result?.success) {
          if (onSuccess) {
            onSuccess(result?.data);
          }
          dispatchToast(
            dispatch,
            "success",
            result?.message || "Checklist reloaded successfully",
          );
          dispatchError(
            dispatch,
            "reloadInstallationPlanReadinessChecklist",
            undefined,
          );
        } else
          elseHandler(
            dispatch,
            "reloadInstallationPlanReadinessChecklist",
            result,
          );
        dispatchLoading(
          dispatch,
          "reloadInstallationPlanReadinessChecklist",
          false,
        );
      })
      .catch(
        catchHandler(dispatch, "reloadInstallationPlanReadinessChecklist"),
      );
  };

export const fetchInstallationPlanQueryFn = async (
  params: any,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.get(`/orders/installation-planning`, {
    params,
    signal,
  });
  const result = responseDataFormate(response.data);
  return result?.data; // Returns { data: [...], count: ... }
};
